export const openNewTab = (url: string) => {
  window.open(url, '_blank', 'noopener, noreferrer');
};

export const redirectToPolar = (url: string) => {
  window.location.href = url;
};